import { Fragment, useState } from "react";

import { Button } from "~/common/components";
import Modal from "~/common/components/Modal";
import { useCurrentTeamMemberContext } from "~/providers/hooks";
import { useInvitationLinks } from "~/providers/hooks/queries/useInvitationLinks";
import { useOrganizationProviders } from "~/providers/hooks/useOrganizationProviders";
import { ConsultationRequestLink } from "../tools/consultationRequestLink";

export const NewConsultationModal = () => {
  const [show, setShow] = useState(false);
  const { data: links } = useInvitationLinks();
  const teamMember = useCurrentTeamMemberContext();
  const currentOrganizationId =
    teamMember.organization_team_members[0].organization_id;
  const { data: providers } = useOrganizationProviders(currentOrganizationId);

  if (!links || links.length === 0) {
    return null;
  }

  return (
    <Fragment>
      <Button
        onClick={() => {
          setShow(true);
        }}
        variant="primary"
        className="h-11"
      >
        New consultation
      </Button>
      <Modal
        title="Consultation request links"
        show={show}
        onClose={() => setShow(false)}
        className="max-h-[90vh] overflow-auto text-gray-700 sm:w-full md:w-5/6 xl:w-2/3"
      >
        <p>
          Consultation request links allow prospective patients to initiate a
          consultation.
        </p>
        {links.map((link) => (
          <ConsultationRequestLink
            key={link.id}
            link={link}
            providers={providers ?? []}
            isReadOnly
          />
        ))}
      </Modal>
    </Fragment>
  );
};
